export const HELP = `hepha: orchestrate Hephaistos sessions from a terminal or an agent.

USAGE
  hepha <command> [args] [--flags]

THE LOOP
  hepha run "<prompt>" --repo owner/repo --follow
      Start a session and follow it until it finishes or asks you something.
      Exit 0 completed · 3 waiting on a human · 1 failed.
      [--title "…"] [--task-type implement|new-project|orchestrator|design|automate]
      [--model <slug>] [--harness claude-code|codex] [--branch <name>]
      [--skill <id>]…
  hepha questions list [--session <id>]
  hepha questions show <batchId>
  hepha questions answer <batchId> --option <questionId>=1,2 --text <questionId>="…"
                                   [--answers '<json array>']
  hepha questions cancel <batchId>
  hepha approvals list | show <id> | approve <id> | reject <id> --mode rework --feedback "…"

SESSIONS
  hepha sessions list [--status active|waiting|done] [--repo owner/repo]
                      [--search "…"] [--page N] [--limit N] [--all]
  hepha sessions get <id>
  hepha sessions logs <id> [--after <sequence>] [--limit N] [--follow]
  hepha sessions send <id> "<message>"
  hepha sessions pause|resume|trash <id>
  hepha sessions kill <id> [--reason "…"]
  hepha sessions checks|pr|verify <id>

CATALOG
  hepha repos
  hepha branches <owner/repo>
  hepha models
  hepha skills

AUTH
  hepha login [--url https://…]     Device authorization: approve it in a browser.
  hepha logout
  hepha whoami
  hepha keys list
  hepha keys create <name> [--scope sessions:read]… [--expires-in-days 90]
  hepha keys revoke <keyId>

ENVIRONMENT
  HEPHA_API_KEY     Act as an agent. Takes precedence over a stored login, so
                    the human-only commands (approvals approve/reject, keys)
                    answer 403 while it is set; unset it to act as yourself.
  HEPHA_TOKEN       A device-flow session token, instead of ~/.hepha/config.json.
  HEPHA_URL         Platform base URL.
  HEPHA_TIMEOUT_MS  Per-request timeout in milliseconds (default 30000).
  HEPHA_FOLLOW_MAX_OUTAGE_SECONDS
                    Give up this long after --follow's first failure, with that
                    failure as the exit code. Unset, it waits for the platform
                    to come back.

GLOBAL FLAGS
  --json          Machine-readable output on stdout. Every command that
                  returns data honours it; login is interactive and does not.
                  Failures print {"ok":false,"error":{…}} and keep their exit code.
  --quiet         Suppress the streamed transcript while following a session.
  --version       Print the version and exit.
  --help          Print this.

Unknown flags and surplus arguments are refused: for an agent, a typo must
fail rather than run with default options.

`;
